import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const navLinks = gsap.utils.toArray(".anchor-links__nav .nav-item-as-anchor");

ScrollTrigger.create({
	trigger: "#stickyAnchorMenu",
	endTrigger: ".site-footer",
	end: "9999999",
	pin: false,
	pinSpacing: false,
	scrub: 1,
});


// create array of objects based on href of navLinks
const panelIDs = "";
navLinks.forEach(function (navLink, index) {
	// console.log(index) // index
	let panelID = navLink.getAttribute("href");
	// console.log(panelID) // value
	panelIDs += ", " + panelID;
});
panelIDs = panelIDs.slice('2');

const panels = gsap.utils.toArray(panelIDs);

panels.forEach((panel, i) => {
	let id = "#" + panel.id;

	ScrollTrigger.create({
		trigger: id,
		start: "top 50%",

		onEnter: () => {
			navLinks.forEach((e) => {
				e.classList.remove("active");
			});
			navLinks[i].classList.add("active");
		},
		onEnterBack: () => {
			navLinks.forEach((e) => {
				e.classList.remove("active");
			});
			navLinks[i].classList.add("active");
		},
	});
});